<template>
  <div id="welcome-container">
    <div class="exam-recommendation-header">
      <h4>Seu resultado:</h4>
      <h1 v-if="examName" style="display: inline;">
        <span>{{ userName }}</span>, este é o
        <span style="color: #00BFB3;">principal exame</span> recomendado para você:
      </h1>
      <h1 class="no-recommendations" v-if="!examName">
        <span>{{ userName }}</span>,
        <span style="color: #00BFB3;">não recomendamos</span> nenhum exame Hilab para você no momento.
      </h1>
    </div>
    <div v-if="examName" class="exam-recommendation">
      <h3>{{ examName }}</h3>
      <br>
      <p v-html="examDetails"></p>
      <button
        @click="open(examLink)"
        >
        <span style="margin: 0 auto;">SAIBA MAIS SOBRE O EXAME</span>
        <i class="material-icons">navigate_next</i>
      </button>
    </div>
    <div v-else style="margin-top: 20px" class="no-exam-recommendation">
      <span>
        Você não possui recomendações de exames Hilab no momento. Porém, é importante lembrar que exames de rotina devem ser realizados regularmente.
        <br>
        <br>
        <b>Não deixe de consultar seu médico e estar sempre em dia com a sua saúde.</b>
      </span>
    </div>
    <div class="exam-recommendation-footer">
      <div v-if="recommendations > 0">
        <p>
          <b>
            Você tem mais
            <span style="color: #00BFB3;">
              {{ recommendations }}
              <span v-if="recommendations > 1">recomendações</span>
              <span v-if="recommendations == 1">recomendação</span>
            </span>
            de exames.
          </b>
          <br>
          <br>Acesse a lista completa pelo aplicativo.
        </p>
      </div>
      <div v-else class="no-recommendations">
        <p>BAIXE O APP HILAB NO SEU CELULAR</p>
      </div>
      <button
        @click="open('https://play.google.com/store/apps/details?id=com.user.hilab.hilab_user')"
      >
        <img style="float: right;" src="/static/download_android.png">
      </button>
      <button
        @click="open('https://itunes.apple.com/br/app/hilab-para-voc%C3%AA/id1391413485?mt=8')"
      >
        <img style="float: left;" src="/static/download_ios.png">
      </button>
    </div>
    <br>
  </div>
</template>

<script>
export default {
  methods: {
    open(link) {
      window.open(link, "_blank");
    }
  },
  created() {
    if (this.examName == null) {
      this.examName = sessionStorage.getItem("mainExamName");
      this.recommendations = sessionStorage.getItem("recommendationsAmount");
      this.examDetails = sessionStorage.getItem("mainExamDetails");
    }
  },
  computed: {
    userName() {
      let name = sessionStorage.getItem("name");
      if (name) {
        return name.split(" ")[0];
      }
      return "";
    }
  },
  data() {
    return {
      recommendations: this.amountOfRecommendations,
      examLink: this.mainRecommendationLink,
      examName: this.mainRecommendationName,
      examDetails: this.mainRecommendationExplanation
    };
  },
  props: {
    amountOfRecommendations: {
      default: 0
    },
    mainRecommendationLink: {
      default: null
    },
    mainRecommendationName: {
      default: null
    },
    mainRecommendationExplanation: {
      default: null
    }
  }
};
</script>

<style lang="scss" scoped>
.no-exam-recommendation {
  font-size: 21px;
}

#welcome-container > .exam-recommendation-footer {
  margin-top: 30px;
  padding-bottom: 60px;

  .no-recommendations > p {
    font-size: 14px;
  }
  p {
    width: 70%;
    margin: auto auto;
    margin-bottom: 20px;
    text-align: center;
    font-family: Muli;
    font-size: 21px;
  }

  button {
    width: calc(50% - 10px);
    height: 60px;
    background: none;
    display: initial;

    img {
      height: 100%;
      width: auto;
    }
  }
}
#welcome-container .exam-recommendation-header {
  max-width: 60%;
}
#welcome-container .exam-recommendation {
  background-color: #eeeeee;
  margin-top: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: calc(20vw - 20px);
  padding-right: calc(20vw - 20px);
  margin-right: calc(-10vw - 20px);
  margin-left: calc(-10vw - 20px);
  color: #003644;
  overflow-x: hidden;

  h3 {
    font-weight: 600;
    font-size: 24px;
  }

  button {
    font-weight: 800;
    color: #003644;
    background: none;
    margin-top: 0px;
  }
}

#welcome-container {
  padding-left: 80px;
  padding-right: 80px;
  padding-top: 120px;
  margin: auto auto;
  max-width: 80vw;
  color: white;
  font-family: Muli;
  text-align: left;

  h1 {
    font-family: Yanone Kaffeesatz;
    max-width: 50%;
  }
  h4 {
    font-weight: 700;
    font-size: 21px;
    max-width: 50%;
  }

  p {
    margin-top: 0px;
    font-size: 16px;
    max-width: 80%;
  }

  button {
    display: inline-flex;
    height: 45px;
    font-weight: 700;
    font-size: 14px;
    border-radius: 4px;
  }
}

@media (max-width: 1200px) {
  #welcome-container .exam-recommendation-header {
    margin-top: calc(20vw - 160px);
    max-width: 100%;
  }
}

@media (min-width: 991px) {
  #welcome-container .exam-recommendation-header {
    h1 {
      font-weight: 400;
      font-size: 50px;
      max-width: none;
    }
  }
}
@media (max-width: 991px) {
  h1 {
    font-weight: 400;
    font-size: 23px;
    max-width: none;
  }
  .no-exam-recommendation {
    font-size: 12px;
  }

  #welcome-container .exam-recommendation-header {
    margin-top: 100px;
    max-width: 100%;
  }

  #welcome-container {
    padding-top: 40px;
    padding-bottom: 40px;
    padding-left: 20px;
    padding-right: 20px;
    max-width: 100%;

    h1 {
      font-size: 23px;
      max-width: none;
    }
    h4 {
      font-size: 14px;
      max-width: none;
    }

    p {
      margin-top: 40px;
      font-size: 12px;
      max-width: none;
    }

    button {
      height: 40px;
      font-size: 12px;
    }
  }

  #welcome-container > .exam-recommendation-footer {
    button {
      width: 100%;

      img {
        float: none !important;
      }
    }

    p {
      width: 100%;
      font-size: 12px;
    }
  }

  #welcome-container .exam-recommendation {
    margin-top: 30px;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    color: #003644;

    p {
      margin-top: 0px;
    }

    h3 {
      font-size: 14px;
    }

    button {
      font-size: 12px;
    }

    i {
      font-size: 16px;
    }

    button,
    i {
      margin-top: auto;
      margin-bottom: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Results.vue